import { ArrowCollapseUpIcon } from './ArrowCollapseUpIcon';

/**
 * author: Michael Richins
 * id 1E02D94D-6931-4CB8-8836-5276B076D811
 * name arrow-collapse-up
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-collapse-up.svg
 * tags
 * - Arrow 
 */
export const ArrowCompressUpIcon = ArrowCollapseUpIcon;
export default ArrowCompressUpIcon